import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import CampaignIcon from '@mui/icons-material/Campaign';
import React from 'react';
import { useNavigate } from 'react-router';
import { useAlertUiTranslation } from '../../../hooks';
import { useAlertsUrl } from '../../../hooks/useAlertsUrl';
import { showNotificationDialog } from '../components';
export function useAlertCreateButton(alertsSentUrl) {
    const { t } = useAlertUiTranslation();
    const alertsSentUrlFromConfig = useAlertsUrl('sent');
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    return {
        label: t('pages.newFromTemplate.createNotification'),
        icon: React.createElement(CampaignIcon, null),
        onClick: () => {
            showNotificationDialog({
                mode: 'notification',
                reviewFormHeader: t('pages.newFromTemplate.reviewAndSend'),
                wizardHeader: t('pages.newFromTemplate.createNotification'),
                onSubmitSuccess: (_data, onClose) => {
                    showAlertSnackbar({
                        message: t('pages.edit.snackbar.notification.sent'),
                        type: 'success',
                        autoHideDuration: 1000,
                    });
                    onClose();
                    navigationContext.navigate(() => navigate(alertsSentUrl !== null && alertsSentUrl !== void 0 ? alertsSentUrl : alertsSentUrlFromConfig));
                },
            });
        },
    };
}
export function useCreateTemplateButton(alertsTemplatesUrl) {
    const { t } = useAlertUiTranslation();
    const alertsTemplatesUrlFromConfig = useAlertsUrl('templates');
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    return {
        label: t(`pages.tables.createTemplate`),
        icon: React.createElement(CampaignIcon, null),
        onClick: () => {
            showNotificationDialog({
                mode: 'template',
                dialogStep: 'wizard',
                reviewFormHeader: t('common.reviewAndSave'),
                wizardHeader: t('pages.tables.createTemplate'),
                onSubmitSuccess: (_data, onClose) => {
                    onClose();
                    navigationContext.navigate(() => navigate(alertsTemplatesUrl !== null && alertsTemplatesUrl !== void 0 ? alertsTemplatesUrl : alertsTemplatesUrlFromConfig));
                },
            });
        },
    };
}
